import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Quote } from 'lucide-react';
import { Button } from '../components/ui/button';
import Reveal from '../components/Reveal';
import { PageHero } from './Products';
import { PROJECTS, HERO_IMAGES } from '../mock';

export default function Projects() {
  return (
    <div className="bg-[#070a12]">
      <PageHero title="Projects" crumb="Projects" image={HERO_IMAGES[1]} />

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="max-w-2xl mb-16">
            <div className="section-eyebrow fire-text">Our Work</div>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl mt-4 text-white">Real Fire Safety Success Stories</h2>
            <p className="text-gray-400 text-lg mt-4">From highrise repairs to full industrial installations — explore how Closefire keeps premises safe across India.</p>
          </Reveal>

          <div className="space-y-10">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.id} delay={80}>
                <article className={`grid lg:grid-cols-2 gap-10 items-center glass rounded-3xl overflow-hidden ${i % 2 ? 'lg:[&>div:first-child]:order-2' : ''}`}>
                  <div className="img-zoom h-72 lg:h-full min-h-[300px]"><img src={p.image} alt={p.title} className="w-full h-full object-cover" /></div>
                  <div className="p-8 lg:p-10">
                    <div className="flex items-center gap-1.5 text-gray-500 text-sm font-heading"><MapPin className="w-4 h-4 text-primary" /> {p.location}</div>
                    <Quote className="w-8 h-8 text-primary/40 mt-4" />
                    <h3 className="font-heading font-bold text-2xl md:text-3xl text-white mt-2">{p.title}</h3>
                    <p className="text-gray-400 mt-4 leading-relaxed">{p.excerpt}</p>
                    <Button asChild className="mt-7 gap-2 bg-gradient-to-r from-primary to-accent"><Link to="/contact">Discuss Your Project <ArrowRight className="w-4 h-4" /></Link></Button>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-24 overflow-hidden">
        <img src={HERO_IMAGES[0]} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#070a12]/85" />
        <Reveal className="relative max-w-3xl mx-auto px-6 text-center">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-white">Have a Project in Mind?</h2>
          <Button asChild size="lg" className="mt-8 gap-2 bg-gradient-to-r from-primary to-accent"><Link to="/contact">Get In Touch <ArrowRight className="w-4 h-4" /></Link></Button>
        </Reveal>
      </section>
    </div>
  );
}
